import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import Typography from "@material-ui/core/Typography";
import {useLocation} from "react-router-dom";
import useGaTracker from '../../common/components/ga/useGaTracker'
import useGa4Tracker from '../../common/components/ga/useGa4Tracker'


const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        height: '100%',
        flexDirection: 'column'
    },
    field: {
        margin: '10px 0',
    },
    paper: {
        marginTop: '10px',
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        alignItems: 'flex-start',
        backgroundColor: 'white',
        padding: '25px',
        borderRadius: '25px'
    },
    contentParagraphs: {
        display: 'flex',
        flexDirection:'column',
        height: '100%',
        overflowY: "auto"
    },
    sessionTitle: {
        fontFamily: 'Lato, sans-serif',
        fontSize: '13px',
        lineHeight: '1.42857143',
        color: '#555',
        fontWeight: '700',
        marginBottom: '10px'
    },
    paragraph: {
        display: 'flex',
        marginTop: '20px',
        flexDirection: 'column',
        color: 'black'
    }
}));

export const Terms = props => {

    const classes = useStyles();

    const [t, i18n] = useTranslation('common');

    const query = new URLSearchParams(useLocation().search);

    const [values, setValues] = useState( { init: false });

    useEffect(function () {
      if (!values.init) {
        const params = {
            lang: query.get("lang")
        };
        if (!!(params.lang)) {
            i18n.changeLanguage(params.lang);
        } else {
            i18n.changeLanguage('en');
        }
        setValues(oldValues => ({
            ...oldValues,
            'init': true
        }));
      }
    }, [values.init, query, i18n]);

    const getSubsections = (sessionIndex) => {
        let subsections = [];
        const count = 16;
        for (let i = 1; i <= count; i++) {
             subsections.push(
               <li style={{margin: '5px 0'}}> {t(`terms.session${sessionIndex}.content.subsections.subsection${i}`)}</li>
             )
        }
        return subsections;
    }

    const renderContent = () => {
        let sessionCountP = [6, 1, 4, 5, 2, 2, 3, 2, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
        let session = [];
        let paragraphs = [];
        for (let i = 1; i <= sessionCountP.length; i++) {
            for (let j = 1; j <= sessionCountP[i-1]; j++) {
                 paragraphs.push(
                   <p style={{marginTop: '5px'}}>
                     {t(`terms.session${i}.content.paragraph${j}`)}
                     {(i === 10 || i === 12 ) && j === 1 &&
                         <span style={{ paddingLeft: '25px', display: 'block', margin: '10px 0' }}>
                             <span>{'Antabel S.A.'} <br/></span>
                             <span>{'Av. Francisco Soca 1531'}<br/></span>
                             <span>{'CP 11600'} <br/></span>
                             <span>{'Montevideo'}<br/></span>
                             <span>{'Uruguay'}<br/></span>
				         </span>
                     }
                     { i === 6 &&  j === 1 &&
                         <ol type='a' style={{ paddingLeft: '25px', display: 'block', margin: '10px 0' }}>
                             {getSubsections(i, j)}
                         </ol>
                     }
                   </p>
                 )
            }
            session.push(
                <div className={classes.paragraph} >
                    <Typography variant="h4" className={classes.sessionTitle}>
                        {t(`terms.session${i}.title`)}
                    </Typography>
                    {paragraphs}
                </div>
            )
            paragraphs = [];
        }
        return session;
   }

    useGaTracker('onboarding-step1-terms-and-conditions');
    useGa4Tracker('onboarding-step1-terms-and-conditions');

   return (
        <Container component="main" maxWidth="lg"  className={classes.container}>
            <div className={classes.paper}>
                <Typography component="h1" variant="h3" margin="normal" style={{ fontWeight: '700'}}>
                    {t('terms.title')}
                </Typography>
                <Typography component="h1" variant="h5" margin="normal" style={{ margin: '15px 0'}}>
                    {t('terms.subtitle')}
                </Typography>
                <div className={classes.contentParagraphs}>
                    {renderContent()}
                </div>
            </div>
        </Container>
    );
}

Terms.propTypes = {
    history: PropTypes.object
};
